import React from 'react';

import { Paper } from '@material-ui/core';

import { useStyles } from './Themable.hoc';
import ProductPreview from './components/ProductPreview';
import { useProductsMode } from '../../state/index.hooks';

const modeSelector = {
    preview: () => <ProductPreview />,
};

const ProductsPane = () => {
    const classes = useStyles();

    const mode = useProductsMode();

    return (
        <Paper className={classes.pane}>
            <div className={classes.wrapper}>
                {mode && modeSelector[mode] && modeSelector[mode]()}
            </div>
        </Paper>
    );
};

export default ProductsPane;
